
import moment from 'moment';
import 'moment/locale/ru';
import Paginate from "@app/vue/Paginator/index.vue";
import AlertSearch from "@app/vue/AlertSearch/index.vue";
import vSelect from '@app/vue/SelectVue/index.vue';
import Loader from '@app/vue/SearchFilter/Loader.vue';
import { apiSearchFilter } from "@app/vue/SearchFilter/api";
import Observer from "@app/vue/Observer/index.vue";
import WorkListSkeleton from "./WorkListSkeleton.vue";
import {createApp} from "vue";

const cityId = (window as any).BaseApp.initData.activeCity;
const areaActive = (window as any).BaseApp.initData.activeCityName.area;
const cityActive = (window as any).BaseApp.initData.activeCityName.name;
const selectCityModal = (window as any).BaseApp.navigation.selectCityModal;

moment.locale('ru');
export default {
    components: { Paginate, AlertSearch, 'v-select': vSelect, Loader, Observer, WorkListSkeleton },
    props: {
        initialIncidents: {
            type: Array,
            default: () => [],
        },
        initialTotalCount: {
            type: Number,
            default: 0,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        count: {
            type: Number,
            default: 20,
        },
        linkSearch: {
            type: String,
            default: '/incident/ajax-incidents/current?page=1',
        },
    },
    data() {
        return {
            incidents: [] as any[],
            totalCount: 0,
            loading: false,
            currentPage: 1,
            paginationKey: 1,
            incidentsCityId: null as number | null,
            incidentsFilter: null as {
                city: string;
                street: string;
                house: string;
                area: Array<any> | null;
            } | null,
            _blockIncident: null as HTMLElement | null,
            _paginationAppIncident: null as any,
            showVueListIncident: false,
            // IncidentSearchFilter data
            streets: [] as any[],
            load: false,
            loadStreet: null as boolean | null,
            cityDefault: { id: cityId, name: 'Территория города' },
            allDefault: { only: false, id: '', name: 'Все территории' },
            cities: [] as any[],
            houses: [] as any[],
            selectedCity: null as any,
            selectedStreet: null as any,
            selectedHouse: null as any,
            noOptionText: 'Ничего не найдено',
            areaActive: areaActive,
            cityActive: cityActive,
            selectCityModal: selectCityModal,
            debounce: null as any,
            enteredValueStreet: '',
            pageStreet: 1,
            totalCountStreet: null as number | null,
            objectsCountStreet: 200,
            countPageStreet: null as number | null,
            isInitializing: true,
            isSearching: false,
            isGettingHouses: false,
            lastSelectedStreetId: null as number | null,
            isRestoringState: false,
        };
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
        showPagination(): boolean {
            // Показываем пагинацию если:
            // 1. totalCount определен и больше 0
            // 2. Всего страниц больше 1
            if (!this.totalCount || this.totalCount === 0) return false;
            const pages = Math.ceil(this.totalCount / this.count);
            return pages > 1;
        },
        pageCount(): number {
            if (!this.totalCount || this.totalCount === 0) return 1;
            return Math.ceil(this.totalCount / this.count);
        },
        hasServerItems(): boolean {
            // Проверяем наличие элементов в серверном списке
            return this.initialTotalCount > 0;
        },
        shouldShowAlert(): boolean {
            // Показываем alert только если нет элементов ни в серверном, ни в Vue списке
            if (!this.showVueListIncident) {
                // Если серверный список еще виден, проверяем серверные данные
                return !this.hasServerItems;
            } else {
                // Если серверный список скрыт, проверяем Vue список
                return this.incidents.length === 0;
            }
        },
    },
    methods: {
        async onApplyFilter(eventData: { type: string; page?: number }) {
            if (eventData.type !== "incident") return;

            // Скрываем серверный блок при первом применении фильтра/пагинации
            this.replaceServerListWithVue();

            // Если указана страница, используем её, иначе сбрасываем на 1
            const targetPage = eventData.page !== undefined ? eventData.page : 1;
            this.currentPage = targetPage;
            this.paginationKey += 1;
            await this.changePageIncidents(targetPage);
        },
        onResetFilter(eventData: { type: string }) {
            if (eventData.type !== "incident") return;

            // Скрываем серверный блок при сбросе фильтра
            this.replaceServerListWithVue();

            this.incidentsFilter = null;
            this.selectedCity = this.allDefault;
            this.selectedStreet = null;
            this.selectedHouse = null;
            this.paginationKey += 1;
            this.currentPage = 1;
            this.onAllSearch();
        },
        onPageChange(page: number) {
            this.changePageIncidents(page);
        },
        onIncidentsData(data: any, filter: any) {
            this.incidents = data.list || [];
            this.totalCount = data.totalCount || 0;
            this.incidentsFilter = {
                city: String(filter.city || ""),
                street: String(filter.street || ""),
                house: String(filter.house || ""),
                area: filter.area || null,
            };
            this.incidentsCityId = filter.city
                ? Number(filter.city)
                : (window as any).BaseApp?.initData?.activeCity || null;
            this.currentPage = 1;
            this.paginationKey += 1;
            this.replaceServerListWithVue();

            // Эмитим новый total обратно в родителя
            this.$emit('update:total', this.totalCount);
        },
        onIncidentsLoad(load: boolean) {
            this.loading = load;
        },
        async changePageIncidents(page: number) {
            this.currentPage = page;
            this.loading = true;
            this.scrollTo();

            // Если список еще не переключен на Vue, значит мы работаем с серверным списком
            if (!this.showVueListIncident && this._blockIncident) {
                // Сразу переключаемся на Vue список, чтобы показать скелетон
                this.replaceServerListWithVue();
            }

            try {
                const data = await apiSearchFilter.fetchSearch(
                    `${this.linkSearch.split('?')[0]}?page=${page}`,
                    this.incidentsFilter?.street ? [Number(this.incidentsFilter.street)] : null,
                    this.incidentsFilter?.house ? [Number(this.incidentsFilter.house)] : null,
                    this.incidentsFilter?.area || (this.incidentsCityId ? [this.incidentsCityId] : null)
                );

                this.incidents = data.list || [];
                this.totalCount = data.totalCount || 0;

                // Эмитим новый total обратно в родителя
                this.$emit('update:total', this.totalCount);
            } catch (error) {
                console.error("Error loading incidents page:", error);
                this.incidents = [];
                this.totalCount = 0;
                this.$emit('update:total', this.totalCount);
            } finally {
                this.loading = false;
            }
        },
        replaceServerListWithVue() {
            if (this.showVueListIncident) return;

            this.showVueListIncident = true;
            // Скрываем серверный блок вместо удаления
            if (this._blockIncident) {
                this._blockIncident.classList.add("d-none");
            }
            // Уничтожаем пагинацию в серверном блоке, так как теперь используется Vue пагинация
            if (this._paginationAppIncident) {
                this._paginationAppIncident.unmount();
                this._paginationAppIncident = null;
            }
        },
        getState() {
            return {
                incidents: [...this.incidents],
                totalCount: this.totalCount,
                currentPage: this.currentPage,
                incidentsFilter: this.incidentsFilter ? { ...this.incidentsFilter } : null,
                incidentsCityId: this.incidentsCityId,
                selectedCity: this.selectedCity,
                selectedStreet: this.selectedStreet,
                selectedHouse: this.selectedHouse,
                showVueListIncident: this.showVueListIncident,
                paginationKey: this.paginationKey,
            };
        },
        setState(state: any) {
            if (state) {
                // Устанавливаем флаг, чтобы предотвратить выполнение запросов в watchers
                this.isRestoringState = true;

                this.incidents = state.incidents || [...this.initialIncidents];
                this.totalCount = state.totalCount !== undefined ? state.totalCount : this.initialTotalCount;
                this.currentPage = state.currentPage || 1;
                this.incidentsFilter = state.incidentsFilter ? { ...state.incidentsFilter } : null;
                this.incidentsCityId = state.incidentsCityId || null;
                this.selectedCity = state.selectedCity || null;
                this.selectedStreet = state.selectedStreet || null;
                this.selectedHouse = state.selectedHouse || null;
                this.showVueListIncident = state.showVueListIncident || false;
                this.paginationKey = state.paginationKey || 1;

                // Управляем видимостью серверного блока
                // Если _blockIncident еще не инициализирован, получаем его заново
                if (!this._blockIncident) {
                    this._blockIncident = document.getElementById("listIncident");
                }
                if (this._blockIncident) {
                    if (this.showVueListIncident) {
                        this._blockIncident.classList.add("d-none");
                    } else {
                        this._blockIncident.classList.remove("d-none");
                    }
                }

                // Сбрасываем флаг после восстановления состояния
                this.$nextTick(() => {
                    this.isRestoringState = false;
                });
            }
        },
        initServerPaginationIncident() {
            // Инициализируем пагинацию в серверном блоке инцидентов, если она еще не инициализирована
            if (this._paginationAppIncident || this.showVueListIncident) return;

            const paginationContainer = document.querySelector(
                ".js-incident-load-more"
            );
            if (!paginationContainer) return;

            const pageCount = Math.ceil(this.totalCount / this.count);
            if (pageCount <= 1) return;

            // Сохраняем ссылку на this для использования в замыкании
            const self = this;

            // Создаем Vue приложение для пагинации
            this._paginationAppIncident = createApp({
                components: { Paginate },
                data() {
                    return {
                        currentPage: 1,
                    };
                },
                methods: {
                    handlePageChange(page: number) {
                        // Вызываем метод changePageIncidents из родительского компонента
                        self.changePageIncidents(page);
                    },
                },
                template: `
                    <paginate
                        :value="currentPage"
                        :page-count="${pageCount}"
                        :page-range="5"
                        :margin-pages="1"
                        :click-handler="handlePageChange"
                        :prev-text="'Назад'"
                        :next-text="'Дальше'"
                        :container-class="'pagination-vue'"
                        :page-class="'pagination-vue__item'"
                    />
                `,
            });

            // Монтируем пагинацию в контейнер
            this._paginationAppIncident.mount(paginationContainer);
        },
        async intersected(element: any, scrollTop: number) {
            clearTimeout(this.debounce);
            this.countPageStreet = Math.ceil((this.totalCountStreet || 0) / this.objectsCountStreet);
            if (this.countPageStreet >= this.pageStreet && this.streets.length >= this.objectsCountStreet) {
                if (!this.selectedCity) {
                    return;
                }
                try {
                    const data = await apiSearchFilter.fetchStreet(
                        this.selectedCity?.id ? this.selectedCity.id : cityId,
                        this.selectedCity?.only,
                        typeof (this.enteredValueStreet) === 'string' ? this.enteredValueStreet : '',
                        this.pageStreet += 1
                    );
                    if (data && data.objects && Array.isArray(data.objects)) {
                        this.streets = [...this.streets, ...data.objects];
                        setTimeout(() => {
                            element.scrollTop = scrollTop;
                        });
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        },
        debounceSearch(event: string) {
            this.enteredValueStreet = event;
            this.pageStreet = 1;
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.onStreets(event);
            }, 600);
        },
        async onStreets(value?: any) {
            this.loadStreet = true;
            if (!this.selectedCity) {
                this.loadStreet = false;
                return;
            }
            try {
                const data = await apiSearchFilter.fetchStreet(
                    this.selectedCity?.id ? this.selectedCity.id : cityId,
                    this.selectedCity?.only,
                    typeof (value) === 'string' ? value : '',
                    1
                );
                if (data && data.objects) {
                    this.streets = data.objects;
                    this.totalCountStreet = data.total_count || 0;
                } else {
                    this.streets = [];
                    this.totalCountStreet = 0;
                }
                this.loadStreet = false;
            } catch (error) {
                console.error(error);
                alert(error);
                this.streets = [];
                this.totalCountStreet = 0;
                this.loadStreet = false;
            }
        },
        async getHouse() {
            if (!this.selectedStreet) {
                return;
            }
            if (this.isGettingHouses) {
                return;
            }
            this.isGettingHouses = true;
            try {
                const data = await apiSearchFilter.fetchHouses(this.selectedStreet.id);
                if (data) {
                    this.houses = data;
                } else {
                    this.houses = [];
                }
            } catch (error) {
                console.error(error);
                alert(error);
                this.houses = [];
            } finally {
                this.isGettingHouses = false;
            }
        },
        async onAllSearch() {
            // Скрываем серверный блок при первом применении фильтра
            this.replaceServerListWithVue();

            this.loading = true;
            this.selectedHouse = null;
            this.selectedStreet = null;
            let areaId = null;
            if (!this.selectedCity) {
                areaId = [cityId];
            } else if (this.selectedCity.name === 'Все территории') {
                areaId = this.cities.map((item: any) => item.id).filter((id: any) => Number(id));
            } else if (this.selectedCity.id) {
                areaId = [this.selectedCity.id];
            } else {
                areaId = [cityId];
            }
            try {
                const data = await apiSearchFilter.fetchSearch(this.linkSearch, null, null, areaId);
                this.onIncidentsData(data, {
                    city: this.selectedCity && this.selectedCity.id === '' ? '' : (this.selectedCity?.id || cityId),
                    street: this.selectedStreet ? this.selectedStreet.id : '',
                    house: this.selectedHouse ? this.selectedHouse.id : '',
                    area: areaId ? areaId : null
                });
            } catch (error) {
                console.error(error);
                alert(error);
            } finally {
                this.loading = false;
            }
        },
        async onSearch() {
            if (!this.selectedStreet) {
                return;
            }
            if (this.isSearching) {
                return;
            }
            this.isSearching = true;

            // Скрываем серверный блок при первом применении фильтра
            this.replaceServerListWithVue();

            this.loading = true;
            try {
                const data = await apiSearchFilter.fetchSearch(
                    this.linkSearch,
                    this.selectedStreet === null ? null : [this.selectedStreet.id],
                    this.selectedHouse !== null ? [this.selectedHouse.id] : null,
                    this.selectedCity.id ? [this.selectedCity.id] : null
                );
                this.onIncidentsData(data, {
                    city: this.selectedCity.id,
                    street: this.selectedStreet.id,
                    house: this.selectedHouse ? this.selectedHouse.id : ''
                });

                if (this.selectedStreet && this.houses.length === 0) {
                    await this.getHouse();
                }
            } catch (error) {
                console.error(error);
                alert(error);
            } finally {
                this.loading = false;
                this.isSearching = false;
            }
        },
        scrollTo(){
            const target = document.querySelector('.m-pageCW-nav');
            const headerOffset = 100;
            const scrollTop = (window.scrollY !== undefined) ? window.scrollY : (window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop);

            const elementPosition = target.getBoundingClientRect().top;
            const offsetPosition = elementPosition + scrollTop - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        },
    },
    async mounted() {
        // Инициализируем с начальными данными
        this.incidents = [...this.initialIncidents];
        this.totalCount = this.initialTotalCount;
        this.incidentsCityId = (window as any).BaseApp?.initData?.activeCity || null;

        // Инициализируем серверную пагинацию если нужно
        this._blockIncident = document.getElementById("listIncident");
        this.$nextTick(() => {
            this.initServerPaginationIncident();
            // Серверный блок остается видимым до первого действия пользователя
        });

        // Инициализируем фильтр
        try {
            const data = await apiSearchFilter.fetchCity(cityId);
            if (data.length === 0) {
                this.cities.unshift(this.allDefault);
                this.cities.unshift(this.cityDefault);
            } else {
                this.cities = data;
                this.cities.unshift(this.cityDefault);
                this.cities.unshift(this.allDefault);
            }
            this.selectedCity = this.allDefault;
            await this.onStreets();
            this.isInitializing = false;
        } catch (error) {
            console.error(error);
            this.isInitializing = false;
        }
    },
    watch: {
        selectedCity: function (newVal: any, oldVal: any) {
            if (this.isInitializing || this.isRestoringState || oldVal === null) {
                return;
            }
            if (this.selectedCity) {
                this.onStreets();
                this.onAllSearch();
            }
        },
        selectedStreet: function (val: any, oldVal: any) {
            if (this.isRestoringState) {
                return;
            }
            if (oldVal && this.lastSelectedStreetId === oldVal.id) {
                return;
            }
            if (val && this.lastSelectedStreetId === val.id) {
                return;
            }
            if (val === null) {
                this.selectedHouse = null;
                this.lastSelectedStreetId = null;
                this.onAllSearch();
                return;
            }
            this.lastSelectedStreetId = val.id;
            this.getHouse();
            this.onSearch();
        },
        selectedHouse: function (val: any) {
            if (this.isRestoringState) {
                return;
            }
            if (this.selectedStreet) {
                this.onSearch();
            }
        },
    },
    emits: ['update:total'],
};
